import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-612d1516"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["Tooltip", "href"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ")", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!

  return (_openBlock(), _createElementBlock("td", {
    Tooltip: _ctx.Field.DynamicToolTip ? _ctx.DeepFetcher(_ctx.item, _ctx.Field.DynamicToolTip) : _ctx.Field.ToolTip,
    href: _ctx.Field.Link && _ctx.DeepFetcher(_ctx.item, _ctx.Field.Link),
    class: _normalizeClass(["GeneralField", _ctx.Field.Class + (_ctx.Field.Bold ? ' F-Bold ': '')]),
    style: _normalizeStyle(_ctx.Field.Style)
  }, [
    (_ctx.Field.Icon !== undefined)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.Clicked && _ctx.Clicked(...args)))
        }, [
          _createVNode(_component_CookiesIcon, {
            class: "SQR1_5em",
            ID: Array.isArray(_ctx.Field.Icon) ? _ctx.DeepFetcher(_ctx.item, _ctx.Field.Icon.ID) : _ctx.Field.Icon.ID,
            Color: _ctx.Field.Icon.Color ? _ctx.Field.Icon.Color : undefined,
            IconSheet: _ctx.Field.Icon.IconsSheet ? _ctx.Field.Icon.IconsSheet : undefined
          }, null, 8, ["ID", "Color", "IconSheet"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.Field.Path)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.Clicked && _ctx.Clicked(...args)))
        }, [
          (_ctx.Field.Hash)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.Field.Hash), 1))
            : _createCommentVNode("", true),
          (!_ctx.Field.MultiLine)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.DeepFetcher(_ctx.item, _ctx.Field.Path)), 1))
            : (_openBlock(), _createElementBlock("span", {
                key: 2,
                innerHTML: _ctx.DeepFetcher(_ctx.item, _ctx.Field.Path).replaceAll('\n', '<br>')
              }, null, 8, _hoisted_4))
        ]))
      : _createCommentVNode("", true),
    (_ctx.Field.Unit)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.Clicked && _ctx.Clicked(...args)))
        }, _toDisplayString(_ctx.Field.Unit), 1))
      : _createCommentVNode("", true),
    (_ctx.Field.DataUnit)
      ? (_openBlock(), _createElementBlock("span", {
          key: 3,
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.Clicked && _ctx.Clicked(...args)))
        }, _toDisplayString(_ctx.DeepFetcher(_ctx.item, _ctx.Field.DataUnit)), 1))
      : _createCommentVNode("", true),
    (_ctx.Field.Secondary !== undefined)
      ? (_openBlock(), _createElementBlock("span", {
          key: 4,
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.Clicked && _ctx.Clicked(...args))),
          class: _normalizeClass(_ctx.Field.Secondary.Bold ? 'F-Bold' : '')
        }, [
          _hoisted_5,
          (_ctx.Field.Secondary.Hash)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.Field.Secondary.Hash), 1))
            : _createCommentVNode("", true),
          (_ctx.Field.Secondary.Path)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.DeepFetcher(_ctx.item, _ctx.Field.Secondary.Path)), 1))
            : _createCommentVNode("", true),
          (_ctx.Field.Secondary.Unit)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.Field.Secondary.Unit), 1))
            : _createCommentVNode("", true),
          (_ctx.Field.Secondary.DataUnit)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.DeepFetcher(_ctx.item, _ctx.Field.Secondary.DataUnit)), 1))
            : _createCommentVNode("", true),
          (_ctx.Field.Secondary.Quantity)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_10, _toDisplayString('X') + _toDisplayString(_ctx.DeepFetcher(_ctx.item, _ctx.Field.Secondary.Quantity)), 1))
            : _createCommentVNode("", true),
          _hoisted_11
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.Field.Quantity)
      ? (_openBlock(), _createElementBlock("span", {
          key: 5,
          style: {"margin-inline-start":"auto","margin-inline-end":"0"},
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.Clicked && _ctx.Clicked(...args)))
        }, _toDisplayString('X') + _toDisplayString(_ctx.DeepFetcher(_ctx.item, _ctx.Field.Quantity)), 1))
      : _createCommentVNode("", true)
  ], 14, _hoisted_1))
}